module.exports = __webpack_public_path__ + "img/no-image.36b49607.png";